/**
 * @license
 * Copyright TWISS.IO
 * All Rights Reserved.
 * Licensed under the MIT License.
 */

import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { ApiService } from "@app/@core/services/api";

@Injectable()
export class DiscService {
  selections: any = {};
  results: any = {};
  progress: any = 0;
  name = "";

  constructor(private apiService: ApiService, private router: Router) {
    this.reset();
  }
  
  set(question, type, option, personality) {
    this.selections[question].option[type] = option;
    this.selections[question].personality[type] = personality;

    let num = question.match(/\d/g);
    num = num.join("");
    num = num * 1;

    if (this.selections[question].option["most"] && this.selections[question].option["min"]) {
      this.progress = ((num + 1.0) / 25) * 100;
    } else if (!this.selections[question].option["most"] || !this.selections[question].option["min"]) {
      this.progress = ((num + 0.5) / 25) * 100;
    }
  }

  reset() {
    this.selections = {
      q1: { option: { most: null, min: null }, personality: { most: null, min: null } },
      q2: { option: { most: null, min: null }, personality: { most: null, min: null } },
      q3: { option: { most: null, min: null }, personality: { most: null, min: null } },
      q4: { option: { most: null, min: null }, personality: { most: null, min: null } },
      q5: { option: { most: null, min: null }, personality: { most: null, min: null } },
      q6: { option: { most: null, min: null }, personality: { most: null, min: null } },
      q7: { option: { most: null, min: null }, personality: { most: null, min: null } },
      q8: { option: { most: null, min: null }, personality: { most: null, min: null } },
      q9: { option: { most: null, min: null }, personality: { most: null, min: null } },
      q10: { option: { most: null, min: null }, personality: { most: null, min: null } },
      q11: { option: { most: null, min: null }, personality: { most: null, min: null } },
      q12: { option: { most: null, min: null }, personality: { most: null, min: null } },
      q13: { option: { most: null, min: null }, personality: { most: null, min: null } },
      q14: { option: { most: null, min: null }, personality: { most: null, min: null } },
      q15: { option: { most: null, min: null }, personality: { most: null, min: null } },
      q16: { option: { most: null, min: null }, personality: { most: null, min: null } },
      q17: { option: { most: null, min: null }, personality: { most: null, min: null } },
      q18: { option: { most: null, min: null }, personality: { most: null, min: null } },
      q19: { option: { most: null, min: null }, personality: { most: null, min: null } },
      q20: { option: { most: null, min: null }, personality: { most: null, min: null } },
      q21: { option: { most: null, min: null }, personality: { most: null, min: null } },
      q22: { option: { most: null, min: null }, personality: { most: null, min: null } },
      q23: { option: { most: null, min: null }, personality: { most: null, min: null } },
      q24: { option: { most: null, min: null }, personality: { most: null, min: null } },
    };

    this.results = {
      most: { D: 0, I: 0, S: 0, C: 0, N: 0 },
      min: { D: 0, I: 0, S: 0, C: 0, N: 0 },
      difference: { D: 0, I: 0, S: 0, C: 0 },
    };

    this.progress = 0;
    this.router.navigateByUrl("/public/disc");
  }

  calculate() {
    let temp_results = {
      name: this.name,
      most: { D: 0, I: 0, S: 0, C: 0, N: 0 },
      min: { D: 0, I: 0, S: 0, C: 0, N: 0 },
      difference: { D: 0, I: 0, S: 0, C: 0 },
    };

    for (let data in this.selections) {
      if (this.selections[data].personality.most == "D") {
        temp_results.most["D"]++;
      } else if (this.selections[data].personality.most == "I") {
        temp_results.most["I"]++;
      } else if (this.selections[data].personality.most == "S") {
        temp_results.most["S"]++;
      } else if (this.selections[data].personality.most == "C") {
        temp_results.most["C"]++;
      } else {
        temp_results.most["N"]++;
      }

      if (this.selections[data].personality.min == "D") {
        temp_results.min["D"]++;
      } else if (this.selections[data].personality.min == "I") {
        temp_results.min["I"]++;
      } else if (this.selections[data].personality.min == "S") {
        temp_results.min["S"]++;
      } else if (this.selections[data].personality.min == "C") {
        temp_results.min["C"]++;
      } else {
        temp_results.min["N"]++;
      }

      if (data == "q24") {
        temp_results.difference["D"] = temp_results.most["D"] - temp_results.min["D"];
        temp_results.difference["I"] = temp_results.most["I"] - temp_results.min["I"];
        temp_results.difference["S"] = temp_results.most["S"] - temp_results.min["S"];
        temp_results.difference["C"] = temp_results.most["C"] - temp_results.min["C"];

        this.results = temp_results;
        this.apiService.post("disc", { data: this.results }).subscribe();
      }
    }
  }
}
